import { injectCriteriaIcons, evaluatePasswordCriteria } from './password-criteria.js'

window.wpbuoy = window.wpbuoy || {}
window.wpbuoy.checkoutPassword = window.wpbuoy.checkoutPassword || {}

// --- Password criteria rules ---
// Shared with the /account registration form — see password-criteria.js.

function evaluate(passwordField, confirmField) {
  evaluatePasswordCriteria(passwordField, confirmField)
}

// --- Loader ---

function showLoader(container) {
  if (!container || container.querySelector('.wpbuoy-loader')) return
  const loader = document.createElement('div')
  loader.className = 'wpbuoy-loader'
  container.appendChild(loader)
}

function hideLoader(container) {
  if (!container) return
  const loader = container.querySelector('.wpbuoy-loader')
  if (loader) loader.remove()
}

// --- Order details gate ---

function updateOrderDetails() {
  const payment = document.querySelector('.ppc-button-wrapper')
  if (!payment) return

  // Standard billing fields only (inside the field wrapper, excludes our custom account section)
  const billingFields = document.querySelectorAll(
    '.woocommerce-billing-fields__field-wrapper input[aria-required="true"], .woocommerce-billing-fields__field-wrapper select[aria-required="true"]'
  )
  const billingFilled = billingFields.length > 0 && Array.from(billingFields).every(f => f.value.trim() !== '')

  const accountSection = document.getElementById('wpbuoy-account-section')
  const sectionVisible = accountSection && accountSection.style.display !== 'none'
  let accountFilled = true
  if (sectionVisible) {
    const signupForm   = document.getElementById('wpbuoy-signup-form')
    const loginForm    = document.getElementById('wpbuoy-inline-login-form')
    const signupActive = signupForm && signupForm.style.display !== 'none'
    const loginActive  = loginForm  && loginForm.style.display  !== 'none'
    if (signupActive) {
      const criteriaItems = document.querySelectorAll('[data-rule]')
      accountFilled = criteriaItems.length > 0
        && Array.from(criteriaItems).every(li => li.classList.contains('criteria-met'))
    } else if (loginActive) {
      accountFilled = false
    }
  }

  payment.classList.toggle('enabled', billingFilled && accountFilled)
}

// --- Account section state ---

const copy = {
  signup: 'No account found for this email \u2014 create a password to continue.',
  login:  'An account already exists for this email \u2014 enter your password below to continue.',
}

function showSection() {
  const section = document.getElementById('wpbuoy-account-section')
  if (section) section.style.display = ''
  updateOrderDetails()
}

function showSignup() {
  const subtext = document.getElementById('wpbuoy-account-subtext')
  const signup  = document.getElementById('wpbuoy-signup-form')
  const login   = document.getElementById('wpbuoy-inline-login-form')
  if (subtext) subtext.textContent  = copy.signup
  if (signup)  signup.style.display = ''
  if (login)   login.style.display  = 'none'
  showSection()
}

function showLogin(email) {
  const subtext    = document.getElementById('wpbuoy-account-subtext')
  const signup     = document.getElementById('wpbuoy-signup-form')
  const login      = document.getElementById('wpbuoy-inline-login-form')
  const emailInput = document.getElementById('wpbuoy-login-email')
  if (subtext)    subtext.textContent   = copy.login
  if (signup)     signup.style.display  = 'none'
  if (login)      login.style.display   = ''
  if (emailInput) emailInput.value      = email || ''
  showSection()
}

// --- Email check ---

let lastCheckedEmail = ''

function checkEmail(email) {
  const section = document.getElementById('wpbuoy-account-section')
  const nonce   = document.getElementById('wpbuoy-check-email-nonce')
  if (!section || !nonce) return

  showLoader(section)

  const body = new FormData()
  body.append('action', 'wpbuoy_check_email')
  body.append('email', email)
  body.append('nonce', nonce.value)

  fetch(wpbuoy_ajax.ajax_url, { method: 'POST', body })
    .then(r => r.json())
    .then(data => {
      if (!data.success) return
      data.data.exists ? showLogin(email) : showSignup()
    })
    .finally(() => hideLoader(section))
}

// --- Inline login (auto-fires on password blur) ---

function handleInlineLogin() {
  const section   = document.getElementById('wpbuoy-account-section')
  const loginWrap = document.getElementById('wpbuoy-inline-login-form')
  const passInput = document.getElementById('wpbuoy-login-password')
  const nonce     = document.getElementById('wpbuoy-login-nonce')
  const redirect  = document.getElementById('wpbuoy-login-redirect')
  const errorEl   = loginWrap ? loginWrap.querySelector('.wpbuoy-login-error') : null
  const email     = document.querySelector('#billing_email') ? document.querySelector('#billing_email').value.trim() : ''

  if (!passInput.value) return
  if (errorEl) errorEl.style.display = 'none'

  showLoader(section)

  const body = new FormData()
  body.append('action', 'wpbuoy_login')
  body.append('username', email)
  body.append('password', passInput.value)
  body.append('rememberme', 0)
  body.append('nonce', nonce.value)

  fetch(wpbuoy_ajax.ajax_url, { method: 'POST', body })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        window.location.href = redirect ? redirect.value : window.location.href
      } else {
        hideLoader(section)
        if (errorEl) {
          errorEl.textContent   = data.data.message
          errorEl.style.display = ''
        }
      }
    })
    .catch(() => hideLoader(section))
}

// --- Init ---

window.wpbuoy.checkoutPassword.init = function () {
  const passwordField = document.querySelector('#account_password')
  const confirmField  = document.querySelector('#account_password_confirm')
  const billingEmail  = document.querySelector('#billing_email')
  const loginPassword = document.getElementById('wpbuoy-login-password')

  // Inject criteria icons
  if (passwordField) {
    injectCriteriaIcons()

    passwordField.addEventListener('input', () => { evaluate(passwordField, confirmField); updateOrderDetails() })

    if (confirmField) {
      confirmField.addEventListener('input', () => { evaluate(passwordField, confirmField); updateOrderDetails() })
      passwordField.addEventListener('keydown', e => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault()
          confirmField.focus()
        }
      })
    }
  }

  // Email check
  if (billingEmail) {
    billingEmail.addEventListener('blur', function () {
      const email = this.value.trim()
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return
      if (email === lastCheckedEmail) return
      lastCheckedEmail = email
      checkEmail(email)
    })

    // On load: if email is already populated (session/autofill), check immediately
    const prefilledEmail = billingEmail.value.trim()
    if (prefilledEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prefilledEmail)) {
      lastCheckedEmail = prefilledEmail
      checkEmail(prefilledEmail)
    }
  }

  // Auto-login on password blur
  if (loginPassword) loginPassword.addEventListener('blur', handleInlineLogin)

  // Order details gate — watch all required billing fields
  const billingRequired = document.querySelectorAll(
    '.woocommerce-billing-fields__field-wrapper input[aria-required="true"], .woocommerce-billing-fields__field-wrapper select[aria-required="true"]'
  )
  billingRequired.forEach(field => {
    field.addEventListener('input', updateOrderDetails)
    field.addEventListener('change', updateOrderDetails)
  })
  if (wpbuoy_ajax.is_logged_in) {
    const payment = document.querySelector('.ppc-button-wrapper')
    if (payment) payment.classList.add('enabled')
  } else {
    updateOrderDetails()
  }
}

document.addEventListener('DOMContentLoaded', window.wpbuoy.checkoutPassword.init)
